/**
 * CustomSpinner Component
 * Move branded spinner/loader using GIF
 * @component
 */

import React from 'react';
import spinnerGif from '../../assets/image/move_spinner.gif';
import { heightOfHeader } from '../../utils/defined';
import { resolveCssVarValue } from '../../utils/CommonFunction';
import { useLocation } from 'react-router-dom';
import i18n from '../../I18';

const CustomSpinner = ({ size = resolveCssVarValue('--fs-xl')*2.35849, fullPage = false, top = heightOfHeader }) => {
  const location = useLocation();
  const isMobile = location.pathname.startsWith('/customer') || location.pathname.startsWith('/dealer-technician');
  if (fullPage) {
    return (
      <div style={{
        position: 'fixed',
        top: top,
        left: (top && !isMobile)? i18n.language === 'es' ? 'calc(var(--fs-xl)*14.56)' : 'calc(var(--fs-xl)*10.849)' : 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        backdropFilter: 'blur(2px)',
        WebkitBackdropFilter: 'blur(2px)',
        height: `calc(100dvh - ${top}px)`,
        zIndex: 9999
      }}>
        <img 
          src={spinnerGif} 
          alt="Loading..." 
          style={{ 
            width: size, 
            height: size,
            objectFit: 'contain'
          }} 
        />
      </div>
    );
  }

  return (
    <img 
      src={spinnerGif} 
      alt="Loading..." 
      style={{ 
        width: size, 
        height: size,
        objectFit: 'contain'
      }} 
    />
  );
};

export default CustomSpinner;
